import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { withSweetAlert } from 'hocs'
import { FaRegEnvelope, FaEdit, FaTrashAlt } from 'react-icons/fa'
import { ContactModalContainer } from 'components/common/modals/ContactModalContainer'
import { EmailContactModalContainer } from 'components/common/modals/EmailContactModalContainer'
import { toEditContactData } from 'components/Contact/serializers'
import * as ACT from 'components/Contact/actions'
import s from './ContactActions.scss'
import cn from 'classnames'
import { isAdmin, getUser } from 'utils/authService'
import { useNavigate } from 'react-router-dom'

const ContactActions = ({ contact, deals }) => {
  const [showContactModal, setShowContactModal] = useState(false)
  const [showEmailContactModal, setShowEmailContactModall] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const toggleContactModal = () => setShowContactModal(!showContactModal)
  const toggleEmailContactModal = () => setShowEmailContactModall(!showEmailContactModal)

  const deleteContact = async () => {
    const { id, firstName } = contact
    const content = deals.length ? (
      <div className={s.alertContent}>
        <p style={{ color: 'red', textAlign: 'center' }}>This action can&#39;t be reverted</p>
        <div>They are part of the following opportunities:</div>
        {deals.map(deal => (
          <div key={`deal-${deal.id}`}>
            <a
              href={`/opportunities/${deal.dealId}`}
              target="_blank"
              rel="noopener noreferrer"
              className={s.link}
            >
              {deal.name}
            </a>
          </div>
        ))}
      </div>
    ) : (
      <p style={{ color: 'red', textAlign: 'center' }}>This action can&#39;t be reverted</p>
    )
    const sweetAlertFactory = withSweetAlert(content)
    sweetAlertFactory(
      {
        title: `Are you sure you want to delete ${firstName}?`,
        buttons: ['No', 'Yes'],
        icon: 'warning'
      },
      () => {
        dispatch({
          type: ACT.CONTACT_DELETE_REQUESTED,
          payload: {
            id,
            navigate
          }
        })
      },
      { cancelConfirmation: false }
    )
  }

  return (
    <>
      <section className={s.actionsContainer}>
        <div className={s.actionIcon} onClick={toggleEmailContactModal}>
          <FaRegEnvelope />
        </div>
        <div className={s.actionIcon} onClick={toggleContactModal}>
          <FaEdit />
        </div>
        {(isAdmin() || getUser().sub === contact.createdBy) && (
          <div className={cn(s.actionIcon, s.deleteIcon)} onClick={deleteContact}>
            <FaTrashAlt />
          </div>
        )}
      </section>
      <div className={s.clearfix} />
      <ContactModalContainer
        toggleContactModal={toggleContactModal}
        showContactModal={showContactModal}
        contact={toEditContactData(contact)}
        actionType={ACT.CONTACT_UPDATE_REQUESTTED}
        isEdit
      />
      <EmailContactModalContainer
        toggleEmailContactModal={toggleEmailContactModal}
        showEmailContactModal={showEmailContactModal}
        contact={contact}
      />
    </>
  )
}

export default ContactActions
